module.exports = __webpack_public_path__ + "static/media/hardwareLcd.1879a34a.png";